import React from 'react';
import styled from 'styled-components/macro';

const LayoutWrapper = styled.section`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 91px);
  margin: 20px;
  overflow-y: auto;
`;

interface Props {
  content: React.ReactNode;
}

const FullLayout = (props: Props) => <LayoutWrapper>{props.content}</LayoutWrapper>;

export default FullLayout;
